module.exports = __webpack_public_path__ + "static/media/20ECE8.8dd84e78.jpg";